import { useAuth0Client } from '@/composables/useAuth0Client';
import { getLoginCallbackUrl } from '@/helpers/Route/routeHelper';
import { Auth0Plugin, createAuth0 } from '@auth0/auth0-vue';
import { isPlatformIs24, isServer } from '../Platform/Platform';

let auth0Instance: Auth0Plugin | undefined;

export function createAuth0Instance(): Auth0Plugin | undefined {
  auth0Instance ??= isServer()
    ? undefined
    : createAuth0(
        {
          domain: import.meta.env.VUE_APP_DOMAIN,
          clientId: import.meta.env.VUE_APP_CLIENT_ID,
          authorizationParams: {
            audience: import.meta.env.VUE_APP_AUDIENCE,
            redirect_uri: getLoginCallbackUrl(),
          },
          useRefreshTokens: true,
          useRefreshTokensFallback: true,
          sessionCheckExpiryDays: 365, // Maximum session lifetime
        },
        { skipRedirectCallback: true },
      );

  return auth0Instance;
}

export const checkUserAuthenticated = async (): Promise<boolean> => {
  const auth0Client = useAuth0Client();
  if (!auth0Client) {
    return false;
  }
  if (import.meta.env.VUE_APP_STAGE === 'prod' || import.meta.env.VUE_APP_STAGE === 'test') {
    if (isPlatformIs24()) {
      return await auth0Client.isAuthenticated.value;
    } else {
      await auth0Client.checkSession();
      return await auth0Client.isAuthenticated.value;
    }
  } else {
    return !!(await auth0Client.getAccessTokenSilently());
  }
};
